export function filtro(
  cadastros,
  equipe,
  profissional,
  situacao,
  exibirVermelhos,
  exibirVerdes
) {
  let cadastros_filtrados = cadastros
  if (equipe !== '') {
    cadastros_filtrados = cadastros_filtrados.filter(
      (item) => item.nu_ine == equipe.nu_ine
    )
  }

  if (profissional !== '') {
    cadastros_filtrados = cadastros_filtrados.filter(
      (item) => item.profissional == profissional
    )
  }

  // if (situacao !== '') {
  //   cadastros_filtrados = cadastros_filtrados.filter((item) => {
  //     let idade = Number(item.idade_anos)
  //     if (situacao.situacao === '11 - 12 anos') {
  //       return idade === 11 || idade == 12
  //     } else if (situacao === '13 - 14 anos') {
  //       return idade === 13 || idade == 14
  //     } else {
  //       return item
  //     }
  //   })
  // }

  if (exibirVermelhos === true) {
    cadastros_filtrados = cadastros_filtrados.filter((item) => {
      if (item.vacinas_pendentes !== null) {
        let vacinas = JSON.parse(item.vacinas_pendentes)
        let vacina = vacinas.find((el) => {
          return el.id_im == 102 || el.id_im == 86
        })
        if (vacina != undefined) {
          return true
        }
      }
    })
  }

  if (exibirVerdes === true) {
    cadastros_filtrados = cadastros_filtrados.filter((item) => {
      if (item.vacinas_aplicadas !== null) {
        let vacinas = JSON.parse(item.vacinas_aplicadas)
        let vacina = vacinas.find((el) => {
          return el.id_imuno == 102 || el.id_imuno == 86
        })
        if (vacina != undefined) {
          return true
        }
      }
    })
  }

  return cadastros_filtrados
}
